import type { TranslationInterface } from '.';

export const BengaliLanguage: TranslationInterface = {
  write_a_message_placeholder: 'একটি বার্তা লিখুন...',
  your_issue_has_been_resolved: 'আপনার সমস্যা সমাধান হয়েছে!',
  new_conversation: 'নতুন কথোপকথন',
  welcome_screen_title: 'আমাদের সাপোর্ট চ্যাটে স্বাগতম',
  welcome_screen_description:
    'আমরা সাহায্য করতে এখানে আছি! একটি কথোপকথন শুরু করুন এবং আমরা যত তাড়াতাড়ি সম্ভব আপনার কাছে ফিরে আসব।',
  your_name_placeholder: 'আপনার নাম',
  your_email_placeholder: 'আপনার ইমেইল ঠিকানা',
  start_chat_button: 'সাপোর্টের সাথে কথা বলুন',
  start_chat_button_loading: 'সংযোগ হচ্ছে...',
  i_need_more_help: 'আমার আরও সাহায্য দরকার',
  this_was_helpful: 'এটি সহায়ক ছিল',
  optional: 'ঐচ্ছিক',
  no_conversations_yet: 'এখনো কোনো কথোপকথন নেই',
  back_to_conversations: 'কথোপকথনে ফিরে যান',
  closed_conversations: 'বন্ধ কথোপকথন',
  csat_title: 'আপনার কথোপকথন কেমন ছিল?',
  csat_submitted_title: 'আপনি কথোপকথনটি মূল্যায়ন করেছেন',
  csat_feedback_placeholder: 'আমাদের আরও বলুন... (ঐচ্ছিক)',
  follow_up_placeholder: 'আরও জিজ্ঞাসা করুন…',
  companion_layout_label: 'লেআউট',
  companion_layout_floating: 'ভাসমান',
  companion_layout_sidebar: 'সাইডবার',
  companion_layout_fullscreen: 'পূর্ণ পর্দা',
  companion_close: 'বন্ধ করুন',
  companion_history: 'কথোপকথনের ইতিহাস',
  companion_expand_chat: 'চ্যাট প্রসারিত করুন',
  companion_sidebar_dock_label: 'ডক',
  companion_sidebar_side_label: 'পাশ',
  companion_sidebar_left: 'বাম',
  companion_sidebar_right: 'ডান',
  companion_resize_chat: 'চ্যাটের আকার পরিবর্তন করুন',
  scroll_to_bottom: 'নিচে স্ক্রল করুন',
  thinking: 'ভাবছি…',
  running: 'চলছে…',
  steps: 'ধাপ',
  step_arguments: 'আর্গুমেন্ট',
  step_result: 'ফলাফল',
  attach_files:
    'ছবি, ভিডিও, PDF বা স্প্রেডশিট সংযুক্ত করুন (সর্বোচ্চ আকার 25 MB)',
  mark_page_active:
    'চিহ্নিত করতে পৃষ্ঠার যেকোনো কিছুতে ক্লিক করুন — বাতিল করতে Esc চাপুন',
  mark_page: 'পৃষ্ঠার কোনো কিছু সম্পর্কে জিজ্ঞাসা করতে সেটি চিহ্নিত করুন',
  stop_response: 'উত্তর থামান',
  copy_reply: 'উত্তর কপি করুন',
  mentions_empty: 'কোনো মিল নেই',
  copied: 'কপি করা হয়েছে',
  send_message: 'বার্তা পাঠান',
  upload_failed: 'আপলোড ব্যর্থ হয়েছে: {error}',
  remove_attachment: 'সংযুক্তি সরান',
  json_no_items: 'কোনো আইটেম নেই',
  json_no_data: 'কোনো ডেটা নেই',
  json_no_chart_data: 'চার্টের জন্য কোনো ডেটা নেই',
  json_unsupported: 'সমর্থিত নয়: {type}',
  json_see_less: 'কম দেখুন',
  json_phone_agent: 'ফোন এজেন্ট',
  json_phone_agent_test: 'ওয়েবে পরীক্ষা করুন',
  page_context_remove: 'পেজ প্রসঙ্গ সরান',
  json_see_more: 'আরও {count}টি দেখুন',
  queued_label: '{count} সারিতে আছে',
  remove_queued_message: 'সারি থেকে বার্তা সরান',
  send_queued_now: 'সারির বার্তাগুলি এখনই পাঠান',
  turn_failed_message: 'কিছু ভুল হয়েছে এবং উত্তরটি আসেনি।',
  turn_failed_retry: 'আবার চেষ্টা করুন',
  page_mark_hint: 'চিহ্নিত করতে যেকোনো কিছুতে ক্লিক করুন',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'বাক্স',
  page_mark_shape_circle: 'বৃত্ত',
  page_mark_shape_arrow: 'তীর',
  page_mark_shape_bracket: 'বন্ধনী',
  page_mark_shape_underline: 'নিম্নরেখা',
  page_mark_shape_highlight: 'হাইলাইট',
  page_mark_shape_strike_through: 'মাঝে দাগ',
  page_mark_shape_crossed_off: 'ক্রস করে কাটা',
  page_mark_shape_aria: 'চিহ্নের আকৃতি: {shape}',
  page_mark_note_placeholder: 'একটি নোট যোগ করুন… (সংযুক্ত করতে Enter চাপুন)',
  page_mark_attach: 'চিহ্ন সংযুক্ত করুন',
  page_mark_remove: '{label} সরান',
  page_mark_region: 'চিহ্নিত অঞ্চল',
  page_mark_default_message: 'এটি কী?',
  file_rejected: 'ফাইলের ধরন সমর্থিত নয় অথবা ফাইলটি খুব বড়।',
  dictate: 'ডিক্টেট করুন',
  stop_dictation: 'ডিক্টেশন বন্ধ করুন',
  dictation_mic_blocked: 'ডিক্টেট করতে মাইক্রোফোন অ্যাক্সেসের অনুমতি দিন',
  dictation_unavailable: 'ডিক্টেশন এখন উপলব্ধ নয়',
  questions_back: 'পেছনে',
  questions_next: 'পরবর্তী',
  questions_send: 'পাঠান',
  questions_type_answer: 'আমি লিখে দিচ্ছি',
  questions_answer_placeholder: 'আপনার উত্তর লিখুন…',
  close_conversation_title: 'কথোপকথন বন্ধ করুন',
  close_conversation_description:
    'আপনি কি নিশ্চিত যে আপনি এই কথোপকথনটি বন্ধ করতে চান?',
  close_conversation_cancel: 'না',
  close_conversation_confirm: 'হ্যাঁ',
  dialog_close: 'বন্ধ করুন',
  zoom_in: 'বড় করুন',
  zoom_out: 'ছোট করুন',
  reset_zoom: 'জুম রিসেট করুন',
  support_chat_aria_label: 'সাপোর্ট চ্যাট',
};
